let stateInit = localStorage.getItem("lotteries") || [];
export default (state = stateInit, action) => {
    switch (action.type) {
        case 'setLottery':
            if (action.payload)
                return [...action.payload];
            else {
                return []
            }
        default:
            return state
    }
}